export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-black text-white mt-12">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4">
            <img
              src="/usc-logo-white.svg"
              alt="University of South Carolina"
              className="h-8 w-auto"
            />
            <div className="text-sm">
              <p>&copy; {currentYear} University of South Carolina</p>
              <p className="text-gray-400 text-xs mt-0.5">
                Division of Information Technology · AI Day Conference
              </p>
            </div>
          </div>
          
          <div className="flex gap-6 text-sm">
            <a
              href="https://sc.edu"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
            >
              sc.edu
            </a>
            <a
              href="https://sc.edu/about/offices_and_divisions/division_of_information_technology/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
            >
              Division of IT
            </a>
            <a
              href="https://sc.edu/about/offices_and_divisions/division_of_information_technology/ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
            >
              Garnet AI Foundry
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
